export default function DSA_Edmonds_Karp() {
  return <div>DSA_Edmonds_Karp Component</div>;
}
